import { AccountInfoAccount, UserInfo } from "@/api/rest/models/account";
import { Building } from "@/api/rest/models/building";
import { HouseholdData } from "@/api/rest/models/household";

type HouseholdAccountSelectionData = Pick<HouseholdData, "accounts"> & {
  building: Pick<Building, "ownerAccountIds">;
};

export const getAvailableHouseholdAccounts = (
  user: UserInfo | null | undefined,
  householdData: HouseholdAccountSelectionData | null | undefined,
): AccountInfoAccount[] => {
  if (!user || !householdData) {
    return [];
  }

  const eligibleAccountIds = new Set([
    ...householdData.accounts.map((account) => account.id),
    ...householdData.building.ownerAccountIds,
  ]);
  return user.accounts.filter((account) => eligibleAccountIds.has(account.id));
};
